// extracted by mini-css-extract-plugin
module.exports = {"base":"SectionDivider_base__wxxGY"};